import { IContactRepository } from '../../../domain/repositories/contact.repository.interface';
import { ContactSettings } from '../../../domain/entities/contact-settings.entity';
import {
  UpdateContactSettingsDTO,
  SendTestEmailDTO,
} from '../../dtos/contact/contact-settings.dto';

export class GetContactSettingsUseCase {
  constructor(private readonly repository: IContactRepository) {}

  public async execute(): Promise<ContactSettings> {
    return this.repository.getSettings();
  }
}

export class GetPublicContactSettingsUseCase {
  constructor(private readonly repository: IContactRepository) {}

  public async execute(): Promise<{ isEnabled: boolean }> {
    return this.repository.getPublicSettings();
  }
}

export class UpdateContactSettingsUseCase {
  constructor(private readonly repository: IContactRepository) {}

  public async execute(data: UpdateContactSettingsDTO): Promise<ContactSettings> {
    return this.repository.updateSettings(data);
  }
}

export class SendTestEmailUseCase {
  constructor(private readonly repository: IContactRepository) {}

  public async execute(data: SendTestEmailDTO): Promise<{ success: boolean; message?: string }> {
    return this.repository.sendTestEmail(data);
  }
}
